import { useQuery } from "@tanstack/react-query";
import { CalendarDays } from "lucide-react";

import { orpc } from "@/client";
import { PessoaLabels } from "@/lib/labels";
import { AgendaLabels } from "@/lib/labels/agenda";
import { djs } from "@/lib/djs";
import { cn } from "@/lib/utils";

import { SideBlock } from "./ficha-sections";

export function FichaAgenda({ personId }: { personId: number }) {
	const { data } = useQuery(
		orpc.agenda.upcomingForPerson.queryOptions({ input: { person_id: personId } }),
	);

	if (!data || data.length === 0) {
		return null;
	}

	return (
		<SideBlock icon={<CalendarDays className="size-4" />} title={PessoaLabels.side.agenda}>
			<div className="flex flex-col gap-3">
				{data.map((event) => (
					<div key={event.start_at} className="flex items-start gap-2.5">
						<span
							className={cn(
								"mt-1.5 size-2 shrink-0 rounded-full",
								AgendaLabels.tipoDot[event.tipo],
							)}
						/>

						<div className="min-w-0 flex-1">
							<div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
								<span className="text-sm font-semibold text-foreground">
									{AgendaLabels.tipo[event.tipo]}
								</span>

								<span className="font-mono text-xs text-muted-foreground">
									{djs(event.start_at).format("DD/MM HH:mm")}
								</span>

								<span
									className={cn(
										"rounded-md border px-1.5 py-0.5 text-xs font-medium leading-none",
										AgendaLabels.statusChip[event.status],
									)}
								>
									{AgendaLabels.status[event.status]}
								</span>
							</div>

							{!!event.obs && (
								<p className="mt-0.5 text-xs leading-snug text-muted-foreground">{event.obs}</p>
							)}
						</div>
					</div>
				))}
			</div>
		</SideBlock>
	);
}
